//src/hooks/useCachedFetch.js

import { useRef } from 'react';

/**
 * Возвращает функцию fetchCached(key, fn)
 *  • key  – строка-идентификатор запроса
 *  • fn   – async-функция, которая реально делает запрос и возвращает data
 *  Кэш живёт ttlMs миллисекунд.
 */
export const useCachedFetch = (ttlMs = 30_000) => {
  const cache = useRef(new Map());

  return async (key, fn) => {
    const now = Date.now();
    const cached = cache.current.get(key);

    if (cached) {
      if (cached.data && now - cached.ts < ttlMs) return cached.data; // свежие данные
      if (cached.promise) return cached.promise;                       // запрос уже идёт
    }

    const promise = fn().then(data => {
      cache.current.set(key, { ts: Date.now(), data });
      return data;
    }).finally(() => {
      const entry = cache.current.get(key);
      if (entry) delete entry.promise;
    });

    cache.current.set(key, { promise });
    return promise;
  };
};
